import { useAccountStore } from '@/store/use-account-store';
import { FilledOrder, useOrdersStore } from '@/store/use-orders-store';
import { OrderStatus } from '@/types';
import { formatDate } from '@/utils/value-format';
import { ColumnDef } from '@tanstack/react-table';

type Props = {
  orderId: string;
};

export default function Time({ orderId }: Props) {
  const address = useAccountStore((state) => state.address);
  const time = useOrdersStore((state) => {
    const { orders } = state.getOrders(address);
    const order = orders[orderId];
    switch (order.status) {
      case OrderStatus.FILLED:
      case OrderStatus.PARTIALLY_FILLED:
        return order.lastFilledTime || order.postTime;
      default:
        return order.postTime;
    }
  });
  return formatDate(new Date(time), {
    showTime: true,
    showSeconds: true,
  });
}

export const timeAccessorFn = (id: string) => {
  const { address } = useAccountStore.getState();
  const { orders } = useOrdersStore.getState().getOrders(address);
  return orders[id].status === OrderStatus.FILLED ||
    orders[id].status === OrderStatus.PARTIALLY_FILLED
    ? (orders[id] as FilledOrder).lastFilledTime || orders[id].postTime
    : orders[id].postTime;
};
